import { backend_url, uninterceptedAxiosInstance, qs } from "../common/commonVariables";

export const getDashBoardData = async (
    organisationID = "",
    period = [],
    location = [],
    orderType = [],
    people = [],
    categories = [],
    assets = [],
    teams = [],
    priority = [],
    customer = [],
    createSelectedDates = [],
    customSelectedDates = [],
    area = [],
    completedDate = [],
    progressDate = [],
    updatedDates = [],
    reviewDate = [],
    cancelledDate = []
  ) => {
    let startCompletedDate;
    let endCompletedDate;
    let startUpdatedAt;
    let endUpdatedAt;
    let startProgressDate;
    let endProgressDate;
    let startReviewDate;
    let endReviewDate;
    let startCancelledDate;
    let endCancelledDate;
    let startcreatedAt;
    let endcreatedAt;
    let startdueDate;
    let enddueDate;
  
    if (completedDate?.length === 1) {
      startCompletedDate = completedDate[0];
    } else if (completedDate?.length === 2) {
      startCompletedDate = completedDate[0];
      endCompletedDate = completedDate[1];
    }
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
    if (progressDate?.length === 1) {
      startProgressDate = progressDate[0];
    } else if (progressDate?.length === 2) {
      startProgressDate = progressDate[0];
      endProgressDate = progressDate[1];
    }
    if (reviewDate?.length === 1) {
      startReviewDate = reviewDate[0];
    } else if (reviewDate?.length === 2) {
      startReviewDate = reviewDate[0];
      endReviewDate = reviewDate[1];
    }
    if (cancelledDate?.length === 1) {
      startCancelledDate = cancelledDate[0];
    } else if (cancelledDate?.length === 2) {
      startCancelledDate = cancelledDate[0];
      endCancelledDate = cancelledDate[1];
    }
  
    if (createSelectedDates?.length === 1) {
      startcreatedAt = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startcreatedAt = createSelectedDates[0];
      endcreatedAt = createSelectedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startdueDate = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startdueDate = customSelectedDates[0];
      enddueDate = customSelectedDates[1];
    }
  
    const queryParams = {
    
      organisation: organisationID,
      period: period[0],
      location: location,
      orderType: orderType[0] == "" ? null : orderType[0],
      people: people,
      category: categories,
      assets: assets,
      teams: teams,
      priority: priority,
      customer: customer,
      area: area,
      startcreatedAt: startcreatedAt,
      endcreatedAt: endcreatedAt,
      startdueDate: startdueDate,
      enddueDate: enddueDate,
      startCompletedDate,
      endCompletedDate,
      startUpdatedAt,
      endUpdatedAt,
      startProgressDate,
      endProgressDate,
      startReviewDate,
      endReviewDate,
      startCancelledDate,
      endCancelledDate,
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `work-orders-dashboard?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  
  export const getAssetDashBoardData = async (
    organisationID = "",
    period = [],
    location = [],
    people = [],
    categories = [],
    assets = [],
    teams = [],
    status = [],
    customer = [],
    vendor = [],
    manufacturer = [],
    createSelectedDates = [],
    customSelectedDates = [],
    warrentySelectedDates = [],
    updatedDates = []
  ) => {
    let startPlacedDate;
    let endPlacedDate;
    let startcreatedAt;
    let endcreatedAt;
    let startExDate;
    let endExDate;
    let startUpdatedAt;
    let endUpdatedAt;
    if (warrentySelectedDates?.length === 1) {
      startExDate = warrentySelectedDates[0];
    } else if (warrentySelectedDates?.length === 2) {
      startExDate = warrentySelectedDates[0];
      endExDate = warrentySelectedDates[1];
    }
  
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startcreatedAt = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startcreatedAt = customSelectedDates[0];
      endcreatedAt = customSelectedDates[1];
    }
  
    if (createSelectedDates?.length === 1) {
      startPlacedDate = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startPlacedDate = createSelectedDates[0];
      endPlacedDate = createSelectedDates[1];
    }
  
    const queryParams = {
      // sort: ['id:desc']
      organisation: organisationID,
      period: period[0],
      location: location,
     
      peoples: people,
      category: categories,
      asset: assets,
      teams: teams,
      status: status,
      customer: customer,
      vendor: vendor,
      manufacturer: manufacturer,
      startPlacedDate: startPlacedDate,
      endPlacedDate: endPlacedDate,
      startExDate: startExDate,
      endExDate: endExDate,
      startcreatedAt,
      endcreatedAt,
      startUpdatedAt,
      endUpdatedAt,
   
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `assets-dashboard?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  
  export const getMaintenanceDashBoardData = async (
    organisationID = ""
   
  ) => {
   
    const queryParams = {
     
      organisation: organisationID,
     
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `maintenance-dashboards?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  export const getResponseTimeByPriorityData = async (
    organisationID = "",
    interval = "week",
    filterOptions,
    createSelectedDates = [],
    customSelectedDates = [],
    reviewDate,
    cancelledDate,
    completedDate,
    progressDate,
    updatedDates
  ) => {
    const {
      dueDate,
      location,
      orderType,
      people,
      categories,
      asset,
      teams,
      priority,
      customer,
      area,
    } = filterOptions;
  
    let startCompletedDate;
    let endCompletedDate;
    let startUpdatedAt;
    let endUpdatedAt;
    let startProgressDate;
    let endProgressDate;
    let startReviewDate;
    let endReviewDate;
    let startCancelledDate;
    let endCancelledDate;
    let startcreatedAt;
    let endcreatedAt;
    let startdueDate;
    let enddueDate;
  
    if (completedDate?.length === 1) {
      startCompletedDate = completedDate[0];
    } else if (completedDate?.length === 2) {
      startCompletedDate = completedDate[0];
      endCompletedDate = completedDate[1];
    }
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
    if (progressDate?.length === 1) {
      startProgressDate = progressDate[0];
    } else if (progressDate?.length === 2) {
      startProgressDate = progressDate[0];
      endProgressDate = progressDate[1];
    }
    if (reviewDate?.length === 1) {
      startReviewDate = reviewDate[0];
    } else if (reviewDate?.length === 2) {
      startReviewDate = reviewDate[0];
      endReviewDate = reviewDate[1];
    }
    if (cancelledDate?.length === 1) {
      startCancelledDate = cancelledDate[0];
    } else if (cancelledDate?.length === 2) {
      startCancelledDate = cancelledDate[0];
      endCancelledDate = cancelledDate[1];
    }
  
    if (createSelectedDates?.length === 1) {
      startcreatedAt = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startcreatedAt = createSelectedDates[0];
      endcreatedAt = createSelectedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startdueDate = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startdueDate = customSelectedDates[0];
      enddueDate = customSelectedDates[1];
    }
  
    const queryParams = {
      // sort: ['id:desc'],
      organisation: organisationID,
      interval: interval,
      period: dueDate[0],
      location: location,
      orderType: orderType[0] == "" ? null : orderType[0],
      people: people,
      category: categories,
      assets: asset,
      teams: teams,
      priority: priority,
      customer: customer,
      area: area,
      startcreatedAt: startcreatedAt,
      endcreatedAt: endcreatedAt,
      startdueDate: startdueDate,
      enddueDate: enddueDate,
      startCompletedDate,
      endCompletedDate,
      startUpdatedAt,
      endUpdatedAt,
      startProgressDate,
      endProgressDate,
      startReviewDate,
      endReviewDate,
      startCancelledDate,
      endCancelledDate,
     
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `work-order-dashboard/responsetime?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  export const getResolutionTimeByPriorityData = async (
    organisationID = "",
    interval = "week",
    filterOptions,
    createSelectedDates = [],
    customSelectedDates = [],
    reviewDate,
    cancelledDate,
    completedDate,
    progressDate,
    updatedDates
  ) => {
    const {
      dueDate,
      location,
      orderType,
      people,
      categories,
      asset,
      teams,
      priority,
      customer,
      area,
    } = filterOptions;
  
    let startCompletedDate;
    let endCompletedDate;
    let startUpdatedAt;
    let endUpdatedAt;
    let startProgressDate;
    let endProgressDate;
    let startReviewDate;
    let endReviewDate;
    let startCancelledDate;
    let endCancelledDate;
    let startcreatedAt;
    let endcreatedAt;
    let startdueDate;
    let enddueDate;
  
    if (completedDate?.length === 1) {
      startCompletedDate = completedDate[0];
    } else if (completedDate?.length === 2) {
      startCompletedDate = completedDate[0];
      endCompletedDate = completedDate[1];
    }
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
    if (progressDate?.length === 1) {
      startProgressDate = progressDate[0];
    } else if (progressDate?.length === 2) {
      startProgressDate = progressDate[0];
      endProgressDate = progressDate[1];
    }
    if (reviewDate?.length === 1) {
      startReviewDate = reviewDate[0];
    } else if (reviewDate?.length === 2) {
      startReviewDate = reviewDate[0];
      endReviewDate = reviewDate[1];
    }
    if (cancelledDate?.length === 1) {
      startCancelledDate = cancelledDate[0];
    } else if (cancelledDate?.length === 2) {
      startCancelledDate = cancelledDate[0];
      endCancelledDate = cancelledDate[1];
    }
  
    if (createSelectedDates?.length === 1) {
      startcreatedAt = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startcreatedAt = createSelectedDates[0];
      endcreatedAt = createSelectedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startdueDate = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startdueDate = customSelectedDates[0];
      enddueDate = customSelectedDates[1];
    }
  
    const queryParams = {
      // sort: ['id:desc'],
  
      organisation: organisationID,
      interval: interval,
      period: dueDate[0],
      location: location,
      orderType: orderType[0] == "" ? null : orderType[0],
      people: people,
      category: categories,
      assets: asset,
      teams: teams,
      priority: priority,
      customer: customer,
      area: area,
      startcreatedAt: startcreatedAt,
      endcreatedAt: endcreatedAt,
  
      startdueDate: startdueDate,
      enddueDate: enddueDate,
      startCompletedDate,
      endCompletedDate,
      startUpdatedAt,
      endUpdatedAt,
      startProgressDate,
      endProgressDate,
      startReviewDate,
      endReviewDate,
      startCancelledDate,
      endCancelledDate,
     
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `work-order-dashboard/resolutiontime?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  
  export const getCostEstimateTimeData = async (
    organisationID = "",
    interval = "week",
    filterOptions,
    createSelectedDates = [],
    customSelectedDates = [],
    reviewDate,
    cancelledDate,
    completedDate,
    progressDate,
    updatedDates
  ) => {
    const {
      dueDate,
      location,
      orderType,
      people,
      categories,
      asset,
      teams,
      priority,
      customer,
      area,
    } = filterOptions;
  
    let startCompletedDate;
    let endCompletedDate;
    let startUpdatedAt;
    let endUpdatedAt;
    let startProgressDate;
    let endProgressDate;
    let startReviewDate;
    let endReviewDate;
    let startCancelledDate;
    let endCancelledDate;
    let startcreatedAt;
    let endcreatedAt;
    let startdueDate;
    let enddueDate;
  
    if (completedDate?.length === 1) {
      startCompletedDate = completedDate[0];
    } else if (completedDate?.length === 2) {
      startCompletedDate = completedDate[0];
      endCompletedDate = completedDate[1];
    }
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
    if (progressDate?.length === 1) {
      startProgressDate = progressDate[0];
    } else if (progressDate?.length === 2) {
      startProgressDate = progressDate[0];
      endProgressDate = progressDate[1];
    }
    if (reviewDate?.length === 1) {
      startReviewDate = reviewDate[0];
    } else if (reviewDate?.length === 2) {
      startReviewDate = reviewDate[0];
      endReviewDate = reviewDate[1];
    }
    if (cancelledDate?.length === 1) {
      startCancelledDate = cancelledDate[0];
    } else if (cancelledDate?.length === 2) {
      startCancelledDate = cancelledDate[0];
      endCancelledDate = cancelledDate[1];
    }
    if (createSelectedDates?.length === 1) {
      startcreatedAt = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startcreatedAt = createSelectedDates[0];
      endcreatedAt = createSelectedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startdueDate = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startdueDate = customSelectedDates[0];
      enddueDate = customSelectedDates[1];
    }
  
    const queryParams = {
     
      organisation: organisationID,
      interval: interval,
      period: dueDate[0],
      location: location,
      orderType: orderType[0] == "" ? null : orderType[0],
      people: people,
      category: categories,
      assets: asset,
      teams: teams,
      priority: priority,
      customer: customer,
      area: area,
      startcreatedAt: startcreatedAt,
      endcreatedAt: endcreatedAt,
  
      startdueDate: startdueDate,
      enddueDate: enddueDate,
      startCompletedDate,
      endCompletedDate,
      startUpdatedAt,
      endUpdatedAt,
      startProgressDate,
      endProgressDate,
      startReviewDate,
      endReviewDate,
      startCancelledDate,
      endCancelledDate,
     
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `work-order-dashboard/estimatecost?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  
  export const getTimeEstimateData = async (
    organisationID = "",
    interval = "week",
    filterOptions,
    createSelectedDates = [],
    customSelectedDates = [],
    reviewDate,
    cancelledDate,
    completedDate,
    progressDate,
    updatedDates
  ) => {
    const {
      dueDate,
      location,
      orderType,
      people,
      categories,
      asset,
      teams,
      priority,
      customer,
      area,
    } = filterOptions;
  
    let startCompletedDate;
    let endCompletedDate;
    let startUpdatedAt;
    let endUpdatedAt;
    let startProgressDate;
    let endProgressDate;
    let startReviewDate;
    let endReviewDate;
    let startCancelledDate;
    let endCancelledDate;
    let startcreatedAt;
    let endcreatedAt;
    let startdueDate;
    let enddueDate;
  
    if (completedDate?.length === 1) {
      startCompletedDate = completedDate[0];
    } else if (completedDate?.length === 2) {
      startCompletedDate = completedDate[0];
      endCompletedDate = completedDate[1];
    }
    if (updatedDates?.length === 1) {
      startUpdatedAt = updatedDates[0];
    } else if (updatedDates?.length === 2) {
      startUpdatedAt = updatedDates[0];
      endUpdatedAt = updatedDates[1];
    }
    if (progressDate?.length === 1) {
      startProgressDate = progressDate[0];
    } else if (progressDate?.length === 2) {
      startProgressDate = progressDate[0];
      endProgressDate = progressDate[1];
    }
    if (reviewDate?.length === 1) {
      startReviewDate = reviewDate[0];
    } else if (reviewDate?.length === 2) {
      startReviewDate = reviewDate[0];
      endReviewDate = reviewDate[1];
    }
    if (cancelledDate?.length === 1) {
      startCancelledDate = cancelledDate[0];
    } else if (cancelledDate?.length === 2) {
      startCancelledDate = cancelledDate[0];
      endCancelledDate = cancelledDate[1];
    }
  
    if (createSelectedDates?.length === 1) {
      startcreatedAt = createSelectedDates[0];
    } else if (createSelectedDates?.length === 2) {
      startcreatedAt = createSelectedDates[0];
      endcreatedAt = createSelectedDates[1];
    }
  
    if (customSelectedDates?.length === 1) {
      startdueDate = customSelectedDates[0];
    } else if (customSelectedDates?.length === 2) {
      startdueDate = customSelectedDates[0];
      enddueDate = customSelectedDates[1];
    }
  
    const queryParams = {
     
      organisation: organisationID,
      interval: interval,
      period: dueDate[0],
      location: location,
      orderType: orderType[0] == "" ? null : orderType[0],
      people: people,
      category: categories,
      assets: asset,
      teams: teams,
      priority: priority,
      customer: customer,
      area: area,
      startcreatedAt: startcreatedAt,
      endcreatedAt: endcreatedAt,
  
      startdueDate: startdueDate,
      enddueDate: enddueDate,
      startCompletedDate,
      endCompletedDate,
      startUpdatedAt,
      endUpdatedAt,
      startProgressDate,
      endProgressDate,
      startReviewDate,
      endReviewDate,
      startCancelledDate,
      endCancelledDate,
      
    };
  
    const query = qs.stringify(queryParams, {
      encodeValuesOnly: true,
    });
  
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `work-order-dashboard/estimatetime?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      return response.data;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
    }
  };
  
